export const container = () => ({
    display: 'flex',
    flexWrap: 'wrap',
    border: 'none',
    width: '100%',
});
